import { TabButton, Type as T } from "@infobis/ui-styles-utils";
import React from "react";
import st from './VariantSwitcher.module.scss';
import { WorkDynamicsVariant } from "@baseTypes/service/dashboard/IWorksDashboardService";

type VariantSwitcherProps = {
    variant: WorkDynamicsVariant
    setVariant: (variant: WorkDynamicsVariant) => void
}
const VariantSwitcher = (props: VariantSwitcherProps) => {
    const {
        setVariant,
        variant
    } = props;

    return (
        <div className={st['switcher']}>
            <TabButton
                size={T.Size.SMALL}
                selected={variant}
                values={[{id: 'cumulative', label: 'Динамика'}, {id: 'differentiated', label: 'Производительность'}]}
                clickHandler={(id: string) => setVariant(id as WorkDynamicsVariant)}
            />
        </div>
    )
}

export default VariantSwitcher;